import { render, staticRenderFns } from "./view_participants.vue?vue&type=template&id=2b8d0a44&"
import script from "./view_participants.vue?vue&type=script&lang=js&"
export * from "./view_participants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8d0a44')) {
      api.createRecord('2b8d0a44', component.options)
    } else {
      api.reload('2b8d0a44', component.options)
    }
    module.hot.accept("./view_participants.vue?vue&type=template&id=2b8d0a44&", function () {
      api.rerender('2b8d0a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/sessions/view_participants.vue"
export default component.exports